import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { isPc, isWeixin } from "../utils/tool.js";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";

const home = () => import("../pages/home"); // 首页
const landing = () => import("../pages/landing"); // 落地页（导航页）
const home2 = () => import("../pages/home-default"); // 首页
const hostLogin = () => import("../pages/host-login"); // 主办登录
const exhibition = () => import("../pages/exhibition"); // 展商
const product = () => import("../pages/product"); //展品
const productDetail = () => import("../pages/product-detail"); //展品详情
const exhibitionDetails = () => import("../pages/exhibition-details"); // 展商详情（专题页）
const shop = () => import("../pages/shop"); // 展商详情->店铺
const shopDetails = () => import("../pages/shop-details"); // 展商详情->店铺->商品详情
const connection = () => import("../pages/connection"); // 人脉
const connectionDetails = () => import("../pages/connection-details"); // 人脉->打招呼
const my = () => import("../pages/my"); // 我的
const exhibitionSurvey = () => import("../pages/exhibition-survey"); //展会详情
const customForm = () => import("../pages/custom-form/custom-form"); // 我的(观众自定义表单)
const customFormEx = () => import("../pages/custom-form/custom-form-Ex"); // 我要参展(展商自定义表单)
const exApply = () => import("../pages/custom-form/exApply"); // 我要参展
const exApplyFinish = () => import("../pages/custom-form/exApply-finish"); // 我要参展完成

const editPersonData = () => import("../pages/edit-person-data"); // 我的->编辑个人资料
const editSupply = () => import("../pages/edit-supply"); // 我的->修改供需
const editAuerbach = () => import("../pages/edit-auerbach"); // 我的->编辑认证资料  申请成为专业买家
const registry = () => import("../pages/registry"); // 注册
const exRegistry = () => import("../pages/ex-registry"); // 注册展商
const auth = () => import("../pages/auth/auth"); // 授权
const OidcCallback = () => import("../pages/auth/OidcCallback"); // 授权中
const silentSignInCallback = () => import("../pages/auth/silentSignInCallback"); // 静默授权
const loginOut = () => import("../pages/auth/loginOut"); // 测试退出登录
const activity = () => import("../pages/activity"); // 活动
const live = () => import("../pages/live"); // 活动直播
const noLive = () => import("../pages/live/noLive"); // 活动无直播
const actReg = () => import("../pages/live/act-reg"); // 活动报名
const actBuy = () => import("../pages/live/act-buy"); // 购票
const actOrder = () => import("../pages/live/act-order"); // 订单详情
const actFinish = () => import("../pages/live/act-finish"); // 订单详情
const error404 = () => import("../pages/error/404"); // 404
const error503 = () => import("../pages/error/503"); // 404
//ZhanShangXiu新增
const exhibitor = () => import("../pages/exhibition-invitation"); // 展商邀请函
const userEvaluation = () => import("../pages/user-evaluation"); // 用户评价
const talkLobby = () => import("../pages/talk-lobby"); // 用户评价
// 头条
const headlines = () => import("../pages/headlines/headlines"); // 头条-资讯
const headlinesNeeds = () => import("../pages/headlines/headlines-needs"); // 头条-供需商机
const headlinesConnect = () => import("../pages/headlines/headlines-connect"); // 头条-行业人脉
const headlinesLive = () => import("../pages/headlines/headlines-live"); // 头条-图片直播
const headlinesHot = () => import("../pages/headlines/headlines-hot"); // 头条-热点话题
const headlinesExinfo = () => import("../pages/headlines/headlines-exinfo"); // 头条-展会概况

const needDetails = () => import("../pages/headlines/need-details"); // 需求
const needPub = () => import("../pages/headlines/needs-pub"); // 话题搜索列表
const hotDetails = () => import("../pages/headlines/hot-details"); // 话题详情
const hotTopDetails = () => import("../pages/headlines/hot-topic-details"); // 讨论话题详情
const hotPub = () => import("../pages/headlines/hot-pub"); // 讨论话题详情
const hotSearch = () => import("../pages/headlines/hot-search"); // 话题搜索列表
const hotSupply = () => import("../pages/headlines/hot-supply"); // 发表供需
const newsDetails = () => import("../pages/headlines/news-details"); // 咨询详情

//用户信息
const myCenter = () => import("../pages/myCenter"); // 我的
const myPapers = () => import("../pages/my-page/my-papers"); // 我的证件
const myContacts = () => import("../pages/my-page/my-contacts"); // 我的人脉
const myBusiness = () => import("../pages/my-page/my-business"); // 我的供需
const myInquiry = () => import("../pages/my-page/my-inquiry"); // 我的询盘
const myTopic = () => import("../pages/my-page/my-topic"); // 我的话题
const visite = () => import("../pages/my-page/my-reg/visite"); // 注册
const editUser = () => import("../pages/my-page/my-reg/editUser"); // 编辑资料
const fillData = () => import("../pages/my-page/my-reg/fillData"); // 完善资料
const exTimeout = () => import("../pages/my-page/my-reg/exTimeout"); // 完善资料

const finishReg = () => import("../pages/my-page/my-reg/finish-reg"); // 注册完成
const myCollect = () => import("../pages/my-page/my-collect"); // 我的关注
const myActivity = () => import("../pages/my-page/my-activity"); // 我的活动
const myLive = () => import("../pages/my-page/my-live"); // 我的直播
const myTrack = () => import("../pages/my-page/my-track"); // 我的足迹
const myMessage = () => import("../pages/my-page/my-message"); // 我的消息
const myFeedback = () => import("../pages/my-page/my-feedback"); // 我的反馈
const myService = () => import("../pages/my-page/my-service"); // 我的客服
const myAccount = () => import("../pages/my-page/my-account"); //我的余额
const sayHello = () => import("../pages/my-page/say-hello"); //打招呼
const myOrder = () => import("../pages/my-page/my-order"); // 预约洽谈
const exLogin = () => import("../pages/my-page/ex-login.vue"); // 预约洽谈
const myTalks = () => import("../pages/my-page/my-talks"); // 我得洽谈
const myTalksUser = () => import("../pages/my-page/my-talks-user"); // 我得洽谈-用户

const boothView = () => import("../pages/booth-view"); //展位图
const hallBuy = () => import("../pages/booth-view/hall-buy"); // 展位图认领
// const hallHome= () => import('../pages/halls/hall-home'); //展位图

// 英文
const signIn = () => import("../pages/sign/index"); // 登录
const Resetpassword = () => import("../pages/sign/Resetpassword"); // 重置密码
const bindEmail = () => import("../pages/sign/bindEmail"); // 绑定邮箱

//洽谈
const chatTalk = () => import("../pages/chat-talk"); // 洽谈间
const chatTalkUser = () => import("../pages/chat-talk-user"); // 洽谈间-用户
const videoTalk = () => import("../pages/video-talk"); // 洽谈视频间

Vue.use(VueRouter);
//把当前导航正要离开的路由名称和判断是否为返回跳转的布尔值，赋值给需要跳转的路由meta对象

const en = [
  {
    path: "/signIn/:id",
    name: "signIn",
    component: signIn,
    meta: {
      title: "Sign in",
      isShare: false,
      redirect: true,
    },
  },
  {
    path: "/resetpassword/:id",
    name: "resetpassword",
    component: Resetpassword,
    meta: {
      title: "Reset password",
      isShare: false,
      redirect: true,
    },
  },
  {
    path: "/bindEmail/:id",
    name: "bindEmail",
    component: bindEmail,
    meta: {
      title: "Associate E-mail",
      isShare: false,
      redirect: true,
    },
  },
  {
    path: "/visite/:id",
    name: "visite",
    component: visite,
    meta: {
      title: "Register",
      isShare: false,
      redirect: true,
    },
  },
  {
    path: "/finishReg",
    name: "finishReg",
    component: finishReg,
    meta: {
      title: "Register",
      isShare: false,
      redirect: true,
    },
  },
  {
    path: "/editUser/:id",
    name: "editUser",
    component: editUser,
    meta: {
      title: "Profile",
      isShare: false,
      redirect: true,
    },
  },
];

const TopNews = [
  {
    path: "/news/:id",
    name: "news",
    component: headlines,
    meta: {
      title: "资讯头条",
      isShare: true,
    },
  },
  {
    path: "/headlinesNeeds/:id",
    name: "headlinesNeeds",
    component: headlinesNeeds,
    meta: {
      title: "供需商机",
      isShare: true,
    },
  },
  {
    path: "/headlinesConnect/:id",
    name: "headlinesConnect",
    component: headlinesConnect,
    meta: {
      title: "行业人脉",
      isShare: true,
    },
  },
  {
    path: "/headlinesLive/:id",
    name: "headlinesLive",
    component: headlinesLive,
    meta: {
      title: "图片直播",
      isShare: true,
    },
  },
  {
    path: "/headlinesHot/:id",
    name: "headlinesHot",
    component: headlinesHot,
    meta: {
      title: "热点话题",
      isShare: true,
    },
  },
  {
    path: "/headlinesExinfo/:id",
    name: "headlinesExinfo",
    component: exhibitionSurvey,
    meta: {
      title: "展会概况",
      isShare: true,
    },
  },
  {
    path: "/newsDetails/:id",
    name: "newsDetails",
    component: newsDetails,
    meta: {
      title: "资讯详情",
      isShare: true,
    },
  },
  {
    path: "/hotDetails",
    name: "hotDetails",
    component: hotDetails,
    meta: {
      title: "话题",
      isShare: true,
    },
  },
  {
    path: "/hotTopDetails",
    name: "hotTopDetails",
    component: hotTopDetails,
    meta: {
      title: "话题详情",
      isShare: true,
    },
  },
  {
    path: "/hotSupply",
    name: "hotSupply",
    component: hotSupply,
    meta: {
      title: "Create a Supply & Demand",
      isShare: false,
    },
  },
  {
    path: "/hotPub",
    name: "hotPub",
    component: hotPub,
    meta: {
      title: "发布话题",
      isBack: true,
      isShare: false,
    },
  },
  {
    path: "/hotSearch",
    name: "hotSearch",
    component: hotSearch,
    meta: {
      title: "选择话题",
      isBack: false,
      isShare: false,
    },
  },
  {
    path: "/needPub",
    name: "needPub",
    component: needPub,
    meta: {
      title: "发布供需",
      isShare: false,
    },
  },
  {
    path: "/needDetails/:id",
    name: "needDetails",
    component: needDetails,
    meta: {
      title: "供需详情",
      isShare: true,
    },
  },
  // {
  //     path: '/visite/:id',
  //     name: 'visite',
  //     component: visite,
  //     meta: {
  //         title: '编辑资料',
  //         isShare:false,
  //     }
  // },
  // {
  //     path: '/editUser/:id',
  //     name: 'editUser',
  //     component: editUser,
  //     meta: {
  //         title: '编辑资料',
  //         isShare:false,
  //     }
  // },
  {
    path: "/fillData",
    name: "fillData",
    component: fillData,
    meta: {
      title: "完善资料",
      isShare: false,
    },
  },
  {
    path: "/exTimeout",
    name: "exTimeout",
    component: exTimeout,
    meta: {
      title: "该展会已被限制访问",
      isShare: false,
    },
  },
  // {
  //     path: '/finishReg',
  //     name: 'finishReg',
  //     component: finishReg,
  //     meta: {
  //         title: '注册成功',
  //         isShare:false,
  //     }
  // },
  {
    path: "/custom-form/:id",
    name: "customForm",
    component: customForm,
    meta: {
      title: "Edit",
      isShare: false,
    },
  },
  {
    path: "/formEx/:id",
    name: "customFormEx",
    component: customFormEx,
    meta: {
      title: "企业入驻",
      isShare: false,
    },
  },
  {
    path: "/exApply/:id",
    name: "exApply",
    component: exApply,
    meta: {
      title: "企业入驻",
      isShare: false,
    },
  },
  {
    path: "/exApplyFinish",
    name: "exApplyFinish",
    component: exApplyFinish,
    meta: {
      title: "企业入驻",
      isShare: false,
    },
  },
];

const routes = [
  {
    path: "/",
    name: "/",
    component: auth,
    meta: {
      title: "ZhanShangXiu",
      isShare: false,
    },
  },
  {
    path: "/landing",
    name: "/landing",
    component: landing,
    meta: {
      title: "CAC ONLINE",
      isShare: true,
    },
  },
  {
    path: "/activity/:id",
    name: "/activity",
    component: activity,
    meta: {
      title: "Activity",
      isShare: true,
    },
  },
  {
    path: "/live",
    name: "/live",
    component: live,
    meta: {
      title: "Activity-Details",
      isShare: true,
    },
  },
  {
    path: "/nolive",
    name: "/nolive",
    component: noLive,
    meta: {
      title: "Activity-Details",
    },
  },
  {
    path: "/actReg/:id",
    name: "/actReg",
    component: actReg,
    meta: {
      title: "活动报名",
      isShare: false,
    },
  },
  {
    path: "/actBuy/:id",
    name: "/actBuy",
    component: actBuy,
    meta: {
      title: "购票",
      isShare: false,
    },
  },
  {
    path: "/actOrder/:id",
    name: "/actOrder",
    component: actOrder,
    meta: {
      title: "订单信息",
      isShare: false,
    },
  },
  {
    path: "/actFinish/:id",
    name: "/actFinish",
    component: actFinish,
    meta: {
      title: "完成购票",
      isShare: false,
    },
  },
  {
    path: "/loginOut",
    name: "/loginOut",
    component: loginOut,
    meta: {
      title: "退出登录",
      isShare: false,
    },
  },
  {
    path: "/OidcCallback",
    name: "/OidcCallback",
    component: OidcCallback,
    meta: {
      title: "Loading...",
      isShare: false,
    },
  },
  {
    path: "/silentSignInCallback",
    name: "/silentSignInCallback",
    component: silentSignInCallback,
    meta: {
      title: "ZhanShangXiu",
      isShare: false,
    },
  },
  {
    path: "/auth",
    name: "/auth",
    component: auth,
    meta: {
      title: "Loading...",
      isShare: false,
    },
  },
  {
    path: "/host-login",
    name: "/host-login",
    component: hostLogin,
    meta: {
      title: "主办登陆",
      isShare: false,
    },
  },
  {
    path: "/home/:id",
    name: "/home",
    component: home,
    meta: {
      title: "ZhanShangXiu",
      isShare: true,
    },
  },
  {
    path: "/exhibition/:id",
    name: "/exhibition",
    component: exhibition,
    meta: {
      title: "Exhibitor",
      isShare: true,
    },
  },
  {
    path: "/product/:id",
    name: "/product",
    component: product,
    meta: {
      title: "Product",
      isShare: true,
    },
  },
  {
    path: "/product-detail",
    name: "/product-detail",
    component: productDetail,
    meta: {
      title: "ProductDetail",
      isShare: true,
    },
  },
  {
    path: "/exhibitor/:id",
    name: "/exhibitor",
    component: exhibitor,
    meta: {
      title: "Invitation",
      isShare: true,
    },
  },
  {
    path: "/user-evaluation",
    name: "/user-evaluation",
    component: userEvaluation,
    meta: {
      title: "用户评价",
      isShare: false,
    },
  },
  {
    path: "/talk-lobby",
    name: "/talk-lobby",
    component: talkLobby,
    meta: {
      title: "洽谈间",
      isShare: true,
    },
  },
  {
    path: "/chat-talk",
    name: "/chat-talk",
    component: chatTalk,
    meta: {
      title: "Chatroom-Exhibitor",
      isShare: false,
    },
  },
  {
    path: "/chat-talk-user",
    name: "/chat-talk-user",
    component: chatTalkUser,
    meta: {
      title: "Chatroom-User",
      isShare: false,
    },
  },
  {
    path: "/video-talk",
    name: "/video-talk",
    component: videoTalk,
    meta: {
      title: "Video-Chatroom",
      isShare: false,
    },
  },
  {
    path: "/exhibition-details",
    name: "/exhibition-details",
    component: exhibitionDetails,
    meta: {
      title: "Exhibitor-Details",
      isShare: true,
    },
  },
  {
    path: "/shop",
    name: "/shop",
    component: shop,
    meta: {
      title: "店铺",
      isShare: true,
    },
  },
  {
    path: "/shopDetails",
    name: "/shopDetails",
    component: shopDetails,
    meta: {
      title: "产品详情",
      isShare: true,
    },
  },
  {
    path: "/connection",
    name: "/connection",
    component: connection,
    meta: {
      title: "人脉",
      isShare: false,
    },
  },
  {
    path: "/connectionDetails",
    name: "/connectionDetails",
    component: connectionDetails,
    meta: {
      title: "专业买家",
      isShare: false,
    },
  },
  {
    path: "/my",
    name: "/my",
    component: my,
    meta: {
      title: "My",
      isShare: false,
    },
  },
  {
    path: "/my-center/:id",
    name: "/my-center",
    component: myCenter,
    meta: {
      title: "Your account",
      isShare: false,
    },
  },
  {
    path: "/my-papers/:id",
    name: "/my-papers",
    component: myPapers,
    meta: {
      title: "Ticket",
      isShare: false,
    },
  },
  {
    path: "/my-contacts/:id",
    name: "/my-contacts",
    component: myContacts,
    meta: {
      title: "我的人脉",
      isShare: false,
    },
  },
  {
    path: "/my-inquiry/:id",
    name: "/my-inquiry",
    component: myInquiry,
    meta: {
      title: "My-Inquiry",
      isShare: false,
    },
  },
  {
    path: "/my-business/:id",
    name: "/my-business",
    component: myBusiness,
    meta: {
      title: "My-Business",
      isShare: false,
    },
  },
  {
    path: "/my-topic/:id",
    name: "/my-topic",
    component: myTopic,
    meta: {
      title: "我的话题",
      isShare: false,
    },
  },
  {
    path: "/my-collect/:id",
    name: "/my-collect",
    component: myCollect,
    meta: {
      title: "Following",
      isShare: false,
    },
  },
  {
    path: "/my-activity/:id",
    name: "/my-activity",
    component: myActivity,
    meta: {
      title: "My-Activity",
      isShare: false,
    },
  },
  {
    path: "/my-live/:id",
    name: "/my-live",
    component: myLive,
    meta: {
      title: "My-Live",
      isShare: false,
    },
  },
  {
    path: "/my-track/:id",
    name: "/my-track",
    component: myTrack,
    meta: {
      title: "我的足迹",
      isShare: false,
    },
  },
  {
    path: "/my-message/:id",
    name: "/my-message",
    component: myMessage,
    meta: {
      title: "Notification",
      isShare: false,
    },
  },
  {
    path: "/my-feedback",
    name: "/my-feedback",
    component: myFeedback,
    meta: {
      title: "Feedback",
      isShare: false,
    },
  },
  {
    path: "/my-service/:id",
    name: "/my-service",
    component: myService,
    meta: {
      title: "Contact Organzier",
      isShare: false,
    },
  },
  {
    path: "/my-account",
    name: "/my-account",
    component: myAccount,
    meta: {
      title: "我的账户",
      isShare: false,
    },
  },
  {
    path: "/my-order/:id",
    name: "/my-order",
    component: myOrder,
    meta: {
      title: "Business",
      isShare: false,
    },
  },
  {
    path: "/my-talks",
    name: "/my-talks",
    component: myTalks,
    meta: {
      title: "Contact records",
      isShare: false,
    },
  },
  {
    path: "/my-talks-user",
    name: "/my-talks-user",
    component: myTalksUser,
    meta: {
      title: "Contact records",
      isShare: false,
    },
  },
  {
    path: "/say-hello",
    name: "/say-hello",
    component: sayHello,
    meta: {
      title: "打招呼",
      isShare: false,
    },
  },
  {
    path: "/editPersonData",
    name: "/editPersonData",
    component: editPersonData,
    meta: {
      title: "编辑个人资料",
      isShare: false,
    },
  },
  {
    path: "/editAuerbach",
    name: "/editAuerbach",
    component: editAuerbach,
    meta: {
      title: "编辑认证资料",
      isShare: false,
    },
  },
  {
    path: "/editSupply",
    name: "/editSupply",
    component: editSupply,
    meta: {
      title: "供需",
      isShare: false,
    },
  },
  {
    path: "/registry",
    name: "/registry",
    component: registry,
    meta: {
      title: "Registry",
      isShare: false,
    },
  },
  {
    path: "/exRegistry",
    name: "/exRegistry",
    component: exRegistry,
    meta: {
      title: "Exhibitor-Registry",
      isShare: false,
    },
  },
  {
    path: "/home2",
    name: "/home2",
    component: home2,
    isShare: false,
  },
  {
    path: "/home",
    name: "/home",
    component: home,
    meta: {
      title: "主办登陆",
    },
  },
  {
    path: "/boothView/:id",
    name: "/boothView",
    component: boothView,
    meta: {
      title: "Floorplan",
      isShare: true,
    },
  },
  {
    path: "/hallBuy/:id",
    name: "hallBuy",
    component: hallBuy,
    meta: {
      title: "展位认领",
      isShare: true,
    },
  },
  {
    path: "/exLogin/:id",
    name: "/exLogin",
    component: exLogin,
    meta: {
      title: "展商登录",
      isShare: false,
    },
  },
  ...TopNews,
  ...en,
  {
    path: "/404",
    name: "/404",
    component: error404,
    meta: {
      title: "404",
      isShare: false,
    },
  },
  {
    path: "/503",
    name: "/503",
    component: error503,
    meta: {
      title: "503",
      isShare: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});
// 路由守卫
router.beforeEach((to, form, next) => {
  if (to.path.indexOf("/auth") != -1 || to.path.indexOf("/OidcCallback") != -1) {
    // 过滤两个地址 不需要请求token
    next();
    return;
  } else {
    const login = sessionStorage.getItem("login");
    // console.log(login,location.pathname,location.pathname + location.search,'--------')
    if (login !== "true") {
      // 如果没有登录 则重新请求
      if (location.pathname !== "/auth" && location.pathname !== "/OidcCallback" && location.pathname.indexOf("/signIn") == -1 && location.pathname.indexOf("/visite") == -1 && location.pathname.indexOf("/resetpassword") == -1 && location.pathname.indexOf("/finishReg") == -1 && location.pathname.indexOf("/editUser") == -1 && location.pathname.indexOf("/bindEmail") == -1) {
        store.commit("setRedirectUrl", location.pathname + location.search);
      }
      console.log(isWeixin(), "是否是微信");
      if (isWeixin()) {
        // 微信的环境
        next({
          path: "/auth",
        });
        return;
      }
    }
  }
  vuexOidcCreateRouterMiddleware(store);
  // 处理jssdk签名,兼容history模式
  console.log("!!!!!!!!!!!! 4 -存入地址：", store.state.url);
  if (!window.url) {
    let winUrl = window.location.href;
    // if(winUrl.indexOf('OidcCallback')!=-1){
    //     winUrl=window.location.href.substring(0,window.location.href.indexOf('OidcCallback')    )
    // }
    store.commit("setUrl", winUrl);
    store.commit("wxShare/setUrl", winUrl);
    window.url = winUrl;
    console.log("!!!!!!!!!!!! 1-存入地址：", winUrl);
  }
  // if (to.fullPath === '/auth') {
  //     store.commit('setRedirectUrl', form.fullPath);
  //     // if (form.query && form.query.exhibitionId) {
  //     //     store.commit('setExhibitionId', form.query.exhibitionId);
  //     // }
  //     // if (form.query && form.query.roomId) {
  //     //     store.commit('setRoomId', form.query.roomId);
  //     // }
  // }
  next();
});

export default router;
